/**
 * Auswahlliste „Antragsbausteine" – dieselbe im Dialog „Nachweis anlegen" und im Nachweis-Detail.
 *
 * Angeboten wird der ganze Katalog, nicht nur die Bausteine im Antrag: Wählt man einen Baustein,
 * der noch fehlt, nimmt der Server ihn mit dem Nachweis auf – derselbe Weg wie im Baum auf der
 * Seite „Antrag".
 *
 * Oben stehen die Bausteine, in die ein Nachweis dieses Katalogeintrags laut Regel gehört
 * (`EvidenceCatalogOption.empfohlene_baustein_typ_ids`, Regel im Backend unter
 * `domain/permits/regeln/`), nach einer Trennlinie der übrige Katalog in ELiA-Reihenfolge.
 */
import { MultiSelectOption } from "../../../common/inputs/MultiSelectDropdown";
import {
  ApplicationComponentTypeOption,
  Evidence,
  EvidenceCatalogOption,
} from "../../../../types";

const option = (type: ApplicationComponentTypeOption): MultiSelectOption => ({
  value: type.id,
  label: type.elia_nummer ? `${type.elia_nummer} ${type.name}` : type.name,
});

export const bausteinOptionen = (
  componentTypeOptions: ApplicationComponentTypeOption[],
  /** Katalogeintrag des Nachweises; ohne ihn (z.B. „Sonstige“) gibt es keine Vorschläge */
  katalogeintrag?: EvidenceCatalogOption,
): MultiSelectOption[] => {
  const empfohlen = new Set(katalogeintrag?.empfohlene_baustein_typ_ids ?? []);
  const oben = componentTypeOptions.filter((type) => empfohlen.has(type.id));
  const rest = componentTypeOptions.filter((type) => !empfohlen.has(type.id));
  return [
    ...oben.map(option),
    ...rest.map((type, index) => ({
      ...option(type),
      dividerBefore: index === 0 && oben.length > 0,
    })),
  ];
};

/** Baustein-Typen, denen der Nachweis zugeordnet ist – die Werte der Mehrfachauswahl */
export const bausteinTypIds = (evidence: Evidence): string[] =>
  evidence.application_components.map(
    (component) => component.application_component_type_id,
  );
